import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import McpToolsText from './tools-text';
import McpChatText from './chat-text';
import connectionLineStore from '@/components/chat-history/connection-line/store';

const McpSummaryLink = observer((props) => {
  const {
    mcpStore,
    event,
    attachment,
    messageItem,
  } = props;

  const handleClick = (type) => {
    HelperCore.log(`点击 html`, type);

    if(attachment.planStepId && mcpStore.currentFileNode?.planStepId == attachment.planStepId){
      return;
    }

    mcpStore.setCurrentFileNode(attachment);

    // 完整的 HTML，自动预览
    if(attachment.content && /\/html\>\s*/i.test(attachment.content)){
      mcpStore.setHtmlPreview(true);
    }
  }

  const handleToggleClick = (e) => {
    e.stopPropagation();

    try{
      mcpStore.chatStore.log({
        action : "click",
        set : "agent_website",
      });
    } catch(e){}

    mcpStore.setPanelMessageId(messageItem.msg_id);
    mcpStore.setCurrentPanelId(event.planStepId, true);
    const id = `${messageItem?.msg_id || ''}_${event?.planStepId || ''}`;
    connectionLineStore.updatePoint(id);
    return;
    
    if(attachment.planStepId && mcpStore.currentFileNode?.planStepId == attachment.planStepId){
      mcpStore.setCurrentFileNode(null)
      return;
    }
    // if (mcpStore.currentFileNode?.type == "html") {
    //   // 同步多个消息html预览状态，完整在下方设置预览
    //   mcpStore.setHtmlPreview(false);
    //   mcpStore.setPanelMessageId(messageItem?.msg_id);
    // }
    mcpStore.setCurrentFileNode(attachment);

    // 完整的 HTML，自动预览
    if(attachment.content && /\/html\>\s*/i.test(attachment.content)){
      mcpStore.setHtmlPreview(true);
    }
  }

  if(!attachment){
    return null;
  }

  const isCurrent = mcpStore.currentFileNode?.type == "html"
    // && mcpStore.currentFileNode.url == attachment.url
    && mcpStore.panelMessageId == messageItem.msg_id
  
  return (
    <div className='mcp-html-card mt-8px'>
      <McpChatText className="!text-16px !leading-22px" event={event}>
        您的网站已成功创建，请点击下方链接查看：
      </McpChatText>

      <div 
        className="text-16px leading-20px text-[#005EE3] mt-12px cursor-pointer"
        onClick={
          () => {
            handleClick("link");
          }
        }
        >
        {attachment.share_url}
      </div>

      <div
        data-id={`${messageItem?.msg_id || ''}_${event?.planStepId || ''}`}
        className={`mcp-html-card-content ui-tools-box w-full mt-12px mb-24px hover:border-black hover:border-opacity-30 border-1px  rounded-12px h-61px flex items-center cursor-pointer bg-white ${isCurrent ? 'border-[#000]' : 'border-[rgba(0,0,0,0.1)]'}  `}
        onClick={
          handleToggleClick
        }
        >
        <img src="https://p2.ssl.qhimg.com/d/inn/6a83b3f9b7e1/mcp_files_link.png" className="size-32px ml-12px mr-8px rounded-8px" />
        <div className="mr-12px w-0 flex-grow">
          <div className="font-bold text-14px leading-20px truncate">
            {attachment.title}
          </div>
          <div className="text-black text-opacity-50 text-12px leading-17px truncate">
            {attachment.share_url}
          </div>
        </div>
        {
          isCurrent ? 
          <div onClick={handleToggleClick} className='w-80px h-32px bg-[rgba(0,0,0,0.06)] hover:bg-[rgba(0,0,0,0.09)] rounded-16px text-center leading-32px mr-12px text-[#000] text-14px'>退出预览</div> : 
          <div onClick={handleToggleClick}  className='w-80px h-32px bg-[#000] hover:bg-[#333] rounded-16px text-center leading-32px mr-12px text-[#fff] text-14px'>立即查看</div>
        }
        
      </div>
    </div>
  )
});
export default McpSummaryLink;